import { Inject, Injectable, LOCALE_ID } from '@angular/core';
// import { inject } from '@angular/core/testing';
// import { KendoInput } from '@progress/kendo-angular-common';
// import { IntlService } from '@progress/kendo-angular-intl';
// import { LocaleService } from './locale.service';

@Injectable({
  providedIn: 'root'
})
export class DateService {
  // locale = 'en-IN'; navigator.language;
  constructor(
    // private intlService: IntlService,
    // private localeService: LocaleService,
    // @Inject(LOCALE_ID) public localeId: string
  ) {
    // this.localeService.set(this.locale);
  }

  convertToUTCDate(date: Date): Date {
    var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
      date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());

    return new Date(now_utc)
  }

  convertUTCDateToLocalDate(date: Date) {
    /* var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
    var offset = date.getTimezoneOffset() / 60;
    var hours = date.getHours();
    newDate.setHours(hours - offset);

    return newDate; */
    return new Date(String(date)+'Z')
  }

  // getDefaultDateFormat() {
  //   return "yyyy-MM-dd"
  // }
}
